<div class="wrapper">
  <mat-card>
    @if(mfaIsLoading$ | async) {
    <div class="loading">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    } @else if(mfaHasFailed$ | async) {
    <app-mfa-fail [errorType]="mfaErrorType$ | async"></app-mfa-fail> } @else {
    <img
      src="../../../assets/images/actabl-blue.png"
      alt="Actabl"
      class="actabl"
    />
    <mat-card-content>
      @if (alertMessage$ | async; as alert) { @if (alert?.message) {
      <div
        class="alert"
        [ngClass]="{
          'alert-danger': alert.hasError,
          'alert-success': !alert.hasError
        }"
        role="alert"
      >
        <div class="alert-message">
          @if (alert.hasError) {
          <mat-icon>error</mat-icon>
          }{{ alert.message | translate }}
        </div>
        <button mat-icon-button aria-label="close" (click)="hideAlert()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      } }
      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label>{{ 'login.username' | translate }}</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              autocomplete="username"
              id="username"
              name="username"
              type="text"
              [(ngModel)]="username"
              required
            />
          </mat-form-field>
        </div>
        <div class="form-group">
          <label>{{ 'login.password' | translate }}</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              autocomplete="current-password"
              id="current-password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="password"
              required
            />
            <mat-icon
              matSuffix
              class="material-icons-outlined"
              (click)="toggleVisibility()"
            >
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </mat-form-field>
          <a
            routerLink="/forgot"
            [queryParams]="{ mode: 'login' }"
            class="forgot-link"
            >{{ 'login.forgotPassword' | translate }}</a
          >
        </div>

        <button
          class="submit-button"
          color="primary"
          type="submit"
          mat-flat-button
          [disabled]="!username || !password || (isLoading$ | async)"
        >
          {{ 'login.logIn' | translate }}
        </button>
      </form>

      <mat-divider></mat-divider>

      <mat-card-footer>
        <p>
          {{
            'login.dontHaveAccount'
              | translate
                : {
                    actabl: 'Actabl'
                  }
          }}
        </p>
      </mat-card-footer>
    </mat-card-content>
    }
  </mat-card>

  <div class="footer">
    <a
      href="https://www.actabl.com/privacy-policy"
      target="_blank"
      class="link-secondary"
      >{{ 'login.privacyPolicy' | translate }}</a
    >
  </div>
</div>
